import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import Button from "@irati/ui/src/Button"
import {H4} from "@irati/ui/src/Typography"

interface Props {
  goBackToTransactions(): void,
  handleTryAgain(): void
}

class ErrorCard extends PureComponent<Props> {
  render() {
    const {goBackToTransactions, handleTryAgain} = this.props
    return (
      <Card>
        <H4>
          <FormattedMessage id="wallet.tenant.topUp.error.text" />
        </H4>
        <Button
          onClick={handleTryAgain}
          primary
          full>
          <FormattedMessage id="wallet.tenant.topUp.error.tryAgain" />
        </Button>
        <Button
          onClick={goBackToTransactions}
          secondary
          full>
          <FormattedMessage id="wallet.tenant.topUp.error.cancel" />
        </Button>
      </Card>
    )
  }
}

export default ErrorCard
